module.exports = {
    Description: {
        StaticInfo: `<p>Once the fracture design is approved and prior to executing  the job, a detailed operational plan to be performed in the field is prepared by the service provider. </p>
      <p>Operational efficiency focuses on the efficient implementation and cost control of the support process, materials, and personnel required to deliver a successful hydraulic fracturing program. Most operational problems and logistical issues generally can be managed or eliminated with robust planning and focused project management.</p>
      <p>The plan should cover all the steps starting with the activities to be undertaken prior to the hydraulic fracture treatment, the fracturing operation itself, up  to the reconnection of the well. </p>
      <p>At this stage, our purpose is to thoroughly review the operational plan with the client, to ensure that the possible situations to be faced during the field during operations are covered. </p>`,
        SectionsInfo: []
    },
    Overview: {
        StaticInfo: `<p>The Operational Plan is specific for the conditions of the site and well, so that there is no standard plan. However, the plan should cover all the steps from the preliminary activities before the hydraulic fracture treatment to the reconnection of the well. </p>
      <p>The Plan should indicate how all equipment is going to be tested to make sure it is in good operating condition. This includes-pressure lines, wellhead, detection of any leaks and others. The Operational Plan also includes the particular issues  of the well and the topics of the safety and operational meetings. Only when these conditions are met, is the well ready for the hydraulic fracturing job.</p>
      <p>The plan must describe in detail the alternate plans or the predetermined stages that can be altered, depending on the site-specific conditions, or if it becomes necessary during the treatment. In general, the plan defines the step by step procedure to carry out the basic stages of the process. </p>`,
        SectionsInfo: [{
                title: "The operational plan should describe",
                content: `
          <strong>Fracturing Planning </strong>
    <ul>
      <li>Logistics </li>
      <li>Wellsite preparation</li>
      <li>Equipment </li>
      <li>Water </li>
      <li>Chemicals </li>
      <li>Proppant </li>
      <li>Fuel</li>
    </ul>
    <strong>Fracturing Equipment </strong>
    <ul>
      <li>High-pressure pumping units</li>
      <li>Hydraulic horsepower</li>
      <li>Transmissions</li>
      <li>Fluid and proppant blending (proportioners)</li>
      <li>Monitoring equipment</li>
      <li>Fracturing-fluid handling</li>
      <li>Bulk handling equipment for proppant</li>
      <li>Additional high-pressure equipment</li>
    </ul>
    <strong>Fracturing Execution </strong>
    <ul>
      <li>Pre-job safety meeting</li>
      <li>Communication</li>
      <li>Contingency planning</li>
      <li>Spotting equipment</li>
      <li>Rig-up</li>
      <li>Pressure testing </li>
      <li>Quality Assurance/Quality Control </li>
      <li>Treatment execution</li>
    </ul>
    <strong>Fracturing Pressure Interpretation </strong>
    <ul>
      <li>Fracture treatment pressure</li>
      <li>Injection tests</li>
      <li>Rate and viscosity</li>
      <li>Diagnostics plots</li>
    </ul>
    <strong>Environmental Considerations </strong>
    <ul>
      <li>Air and noise pollution</li>
      <li>Water pollution</li>
      <li>Spills and solid waste</li>
    </ul>
          `
            },
            {
                title: "Operational risk",
                content: `
        <p>Working with high pressure is a reality of fracturing operations, and a very real danger exists. All technical disciplines and management are involved in the completion, fracturing design, job-execution and post-job evaluation.</p>
    <p>The diverse engineering or science backgrounds of team members can lead to different <strong>mental models</strong> of what the fracture should look like and how it should behave, which, in turn, can be problematic. When implementing fracturing treatments, decisions should first be made with regard to what is known, and secondly, if at all, with regard to what is envisioned. Rapid, time-critical decisions all too often need to be made, and conjecture should be left back in the team room,<strong> with focus placed on the procedural requirements.</strong></p>
    <p>Operations should be kept as simple as possible, but no simpler than the design and the well require.</p>
    <p>To ensure the success of your project, effective risk management is vital in every phase. From the selection of the well, through the operational stages related to the rock, the nearby formations, the placement of the support agent and all subsequent operations.</p>
    <p> As required and authorized, EGEP as your consultant can help you use a structured approach for assessing and managing risks along each stage of the project.</p>
    <p>The service companies have their own protocols for prevention and management of operational and environmental risks as well as emergency management procedures for each of the pieces of equipment to be used in case of situations that may arise during the operation. These must be requested from the contractor for evaluation <strong>prior</strong> to the project field execution.</p>
    <p>Although it is  clear that risk in each project stage and each case is different, a template is shown as an example to identify and perform a preliminary qualitative risk assessment.</p>
    <p>The client, with the consultant´s support, is encouraged to adjust or prepare a table similar or equivalent to the one hereby provided, identifying by mutual agreement (client-consultant) those individual items that are considered to have a significant  impact on the results of the project.</p>
    <p>Below find a partial list of some events that should be included in the evaluation:</p>
    <ul>
      <li>
                        Equipment failure during operation
      </li>
        <li>
                        Pre-fracture mechanical difficulties
      </li>
        <li>
                        Unexpected response during fracturing
      </li>
        <li>
                        Unexpected response after fracturing
      </li>
        <li>
                        Operational problems during the back-flow period
      </li>
        <li>
                        Unexpected problems with materials and supplies during operation
      </li>
        <li>
                        Others that the client and consultant consider pertinent
      </li>
    </ul>
    <br>
    <div style="width:100%;">
    <img style="width:100%;" src='https://firebasestorage.googleapis.com/v0/b/practica-9c4fb.appspot.com/o/2.5%20Overview_Plan_Operacional_RISK_up.JPG?alt=media&token=2960e120-5cf0-41a2-b7fe-d407e542b5c8' />
    </div>
        `
            }
        ]
    },
    Inputs: {
        StaticInfo: `<p> In this section the purpose of EGEP is to help the client with the operational plan review and approval procedures. </p>
    <p>Please consider uploading the Operational Plan provided by the service company and other relevant data. The EGEP consultant can help you review this Operational Plan in order to guarantee that it covers all aspects needed for a successful operation. </p>
      <p>Until the Operational Plan is approved, this is an iterative review process among client, consultant and service company.</p>`,
        SectionsInfo: []
    },
    Deliverables: {
        StaticInfo: `<p>In this section the EGEP consultant will review and discuss his opinion about the Operational Plan and provide a report with the corresponding analysis, conclusions and recommendations.</p>`,
        SectionsInfo: []
    }
}